// Calculation Methods Constants
export const CALCULATION_METHODS = {
  ALL: "all",
  COST_PLUS: "method_costplus",
  NODE_MARGINS: "method_nodemargins",
  VALUE_BASED: "method_valuebased",
};

// Not Applicable Map - Define quais inputs não são aplicáveis por método
export const NOT_APPLICABLE_MAP = {
  [CALCULATION_METHODS.COST_PLUS]: [
    "market02",
    "market03",
    "market04",
    "market05",
  ],
  [CALCULATION_METHODS.NODE_MARGINS]: ["market04", "market05", "chain06"],
  [CALCULATION_METHODS.VALUE_BASED]: ["fin04", "fin05", "market03", "market04"],
};

// Helper function to check if an input is not applicable for a calculation method
export const isInputNotApplicable = (tableId, calculationMethod) => {
  if (!calculationMethod || calculationMethod === CALCULATION_METHODS.ALL) {
    return false;
  }
  return NOT_APPLICABLE_MAP[calculationMethod]?.includes(tableId) || false;
};

// Calculation Method Options (para dropdowns)
export const CALCULATION_METHOD_OPTIONS = [
  { value: CALCULATION_METHODS.ALL, labelKey: "all_methods" },
  { value: CALCULATION_METHODS.COST_PLUS, labelKey: "method_costplus" },
  { value: CALCULATION_METHODS.NODE_MARGINS, labelKey: "method_nodemargins" },
  { value: CALCULATION_METHODS.VALUE_BASED, labelKey: "method_valuebased" },
];

// Calculation Method Options para Cockpit (sem "all_methods")
export const CALCULATION_METHOD_OPTIONS_COCKPIT = [
  { value: CALCULATION_METHODS.COST_PLUS, labelKey: "method_costplus" },
  { value: CALCULATION_METHODS.VALUE_BASED, labelKey: "method_valuebased" },
  { value: CALCULATION_METHODS.NODE_MARGINS, labelKey: "method_nodemargins" },
];
